(function () {

  'use strict';

  function initArisHalloween() {

    const overlay =
      document.getElementById(
        'aris-halloween-overlay'
      );

    if (!overlay) return;

    const intro =
      overlay.querySelector(
        '.aris-halloween-intro'
      );

    const skipButton =
      overlay.querySelector(
        '.aris-intro-skip'
      );

    const keywords = [
      'halloween',
      'october',
      '🎃'
    ];

    const SESSION_KEY =
      'aris_halloween_intro_seen';

    let introTimer = null;

    let introRunning = false;

    /* =====================================================
       FIND ANNOUNCEMENT TEXT
       ===================================================== */

    function getAnnouncementText() {

      const selectors = [
        '[class*="announcement"]',
        '[class*="announce"]',
        '[id*="announcement"]',
        '[id*="announce"]',
        '[data-section-type*="announcement"]',
        '[data-section-type*="announce"]'
      ];

      let text = '';

      document.querySelectorAll(
        selectors.join(',')
      ).forEach(function (element) {

        const rect =
          element.getBoundingClientRect();

        if (
          rect.top < 300 &&
          rect.bottom > 0 &&
          rect.height > 0
        ) {

          text +=
            ' ' +
            (element.textContent || '');

        }

      });

      return text
        .toLowerCase()
        .trim();
    }

    /* =====================================================
       CHECK HALLOWEEN
       ===================================================== */

    function halloweenIsActive() {

      const text =
        getAnnouncementText();

      return keywords.some(
        function (keyword) {

          return text.includes(
            keyword.toLowerCase()
          );

        }
      );

    }

    /* =====================================================
       CLOSE INTRO
       ===================================================== */

    function closeIntro() {

      if (!introRunning) return;

      introRunning = false;

      if (introTimer) {

        clearTimeout(
          introTimer
        );

        introTimer = null;

      }

      overlay.classList.add(
        'intro-closing'
      );

      setTimeout(
        function () {

          overlay.classList.remove(
            'intro-active'
          );

          overlay.classList.remove(
            'intro-closing'
          );

        },
        900
      );

    }

    /* =====================================================
       SHOW INTRO
       ===================================================== */

    function showIntro(
      force = false
    ) {

      if (!intro) return;

      if (introRunning) return;

      /*
        Normal automatic mode:
        only once per browser session.
      */

      if (!force) {

        try {

          if (
            sessionStorage.getItem(
              SESSION_KEY
            ) === '1'
          ) {

            return;

          }

          sessionStorage.setItem(
            SESSION_KEY,
            '1'
          );

        } catch (error) {}

      }

      introRunning = true;

      /*
        Make sure overlay is visible
        before starting the intro.
      */

      overlay.classList.add(
        'is-active'
      );

      overlay.classList.remove(
        'intro-closing'
      );

      /*
        Tiny cinematic delay.
      */

      setTimeout(
        function () {

          if (!introRunning) return;

          overlay.classList.add(
            'intro-active'
          );

        },
        120
      );

      /*
        FULL INTRO DURATION
        6.5 seconds
      */

      introTimer =
        setTimeout(
          closeIntro,
          6500
        );

    }

    /* =====================================================
       UPDATE HALLOWEEN MODE
       ===================================================== */

    function updateHalloween() {

      /*
        VERY IMPORTANT:
        Once the intro has started,
        do not allow the automatic
        announcement checker to
        interrupt it.
      */

      if (introRunning) {

        overlay.classList.add(
          'is-active'
        );

        return;

      }

      const active =
        halloweenIsActive();

      if (active) {

        overlay.classList.add(
          'is-active'
        );

        let alreadySeen = false;

        try {

          alreadySeen =
            sessionStorage.getItem(
              SESSION_KEY
            ) === '1';

        } catch (error) {

          alreadySeen = false;

        }

        if (!alreadySeen) {

          showIntro();

        }

      } else {

        overlay.classList.remove(
          'is-active'
        );

        overlay.classList.remove(
          'intro-active'
        );

        overlay.classList.remove(
          'intro-closing'
        );

      }

    }

    /* =====================================================
       SKIP BUTTON
       ===================================================== */

    if (skipButton) {

      skipButton.addEventListener(
        'click',
        function () {

          closeIntro();

        }
      );

    }

    /* =====================================================
       ESC KEY
       ===================================================== */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          introRunning
        ) {

          closeIntro();

        }

      }
    );

    /* =====================================================
       INITIAL CHECKS
       ===================================================== */

    setTimeout(
      updateHalloween,
      300
    );

    setTimeout(
      updateHalloween,
      900
    );

    setTimeout(
      updateHalloween,
      1800
    );

    setTimeout(
      updateHalloween,
      3000
    );

    /* =====================================================
       WATCH SHOPIFY CHANGES
       ===================================================== */

    const observer =
      new MutationObserver(
        function () {

          updateHalloween();

        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );

    /* =====================================================
       BACKUP CHECK
       ===================================================== */

    setInterval(
      updateHalloween,
      5000
    );

    /* =====================================================
       MANUAL CONTROLS
       ===================================================== */

    window.ArisHalloween = {

      on: function () {

        overlay.classList.add(
          'is-active'
        );

      },

      off: function () {

        introRunning = false;

        if (introTimer) {

          clearTimeout(
            introTimer
          );

          introTimer = null;

        }

        overlay.classList.remove(
          'is-active'
        );

        overlay.classList.remove(
          'intro-active'
        );

        overlay.classList.remove(
          'intro-closing'
        );

      },

      intro: function () {

        showIntro(true);

      },

      reset: function () {

        try {

          sessionStorage.removeItem(
            SESSION_KEY
          );

        } catch (error) {}

      },

      auto: function () {

        updateHalloween();

      }

    };

  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initArisHalloween
    );

  } else {

    initArisHalloween();

  }

})();